import { inject, Injectable, NgZone } from '@angular/core';
import { environment } from '@environment/environment';
import Clarity from '@microsoft/clarity';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private readonly ngZone = inject(NgZone);

  initializeClarity(): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.getClarityKey()) {
        Clarity.init(this.getClarityKey());
      }
    });
  }

  public clarityEvent(eventNameString): void {
    if (this.getClarityKey()) {
      Clarity.event(eventNameString);
    }
  }

  private getClarityKey(): string {
    return environment.clarityProjId;
  }
}
